import script from "./AuthByEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthByEmail.vue?vue&type=script&setup=true&lang=ts"

import "./AuthByEmail.vue?vue&type=style&index=0&id=2ce0fb1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce0fb1a"]])

export default __exports__